const certificadoInitialState = {
  certificados: {
    loading: false,
    error: null,
    data: null,
  },
};

export default certificadoInitialState;
